import { axiosMockAdapterInstance } from "apis/index";
import { getResponseData } from "./index";

const data = {
  currentStep: 3,
  autoWithdrawal: 4,
  userType: 1,
  status: 1,
  localCurrency: "USD",
  fizenpayFeePerc: 0.5,
  id: "6242b77b96633f004182a26b",
  isPendingApproved: false,
  email: "tuandt@sotanext.com",
  supportEmail: "tuandt@sotanext.com",
  wallets: [
    {
      bip44_path: "m/44'/60'/0'",
      currency: "BNB",
      is_mainnet: false,
      provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet",
      wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/bsc/testnet/ws",
      network: "binance-smart-chain-testnet",
      fpMasterContract: "0xE0C209B96cfC112121E3379d71445E5645370432",
      contract: "0x228421241e2cb936f6af7624e3acf160516daccb",
      address: "0x0c5Cd97A7a1f42CAC1d3e7D2De72ce6E123Da222",
      transactionUrl: "https://testnet.bscscan.com/tx/",
    },
    {
      bip44_path: "m/44'/60'/0'",
      currency: "ETH",
      is_mainnet: false,
      provider: "https://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/eth/rinkeby",
      wssProvider: "wss://speedy-nodes-nyc.moralis.io/da36a86b30bd77000f810326/eth/rinkeby/ws",
      network: "ethereum-rinkeby",
      fpMasterContract: "0x032522115812f9A6ddb670e906966cD75b471196",
      contract: "0xf9b240894252eeaa47bd69a29dc53908f225befa",
      address: "0x0c5Cd97A7a1f42CAC1d3e7D2De72ce6E123Da222",
      transactionUrl: "https://rinkeby.etherscan.io/tx/",
    },
  ],
  cryptoCurrencySettings: [
    {
      name: "ZSD",
      slug: "zsd-bsc",
      network: "binance-smart-chain-testnet",
      address: "0xd8051ac98ed64Cc6be0382444965e29aBE9977Ed",
      cmcId: 8772,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
    {
      name: "ETH",
      slug: "eth-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x85C79a17f657d54caf4eF293C8Fd55080e75C15D",
      cmcId: 1027,
      decimal: 18,
      type: "POPULAR",
      gasLimit: 70871,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
    {
      name: "DAI",
      slug: "dai-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
      cmcId: 4943,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
    {
      name: "BNB",
      slug: "bnb-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x0000000000000000000000000000000000000000",
      cmcId: 1839,
      decimal: 18,
      type: "OTHERS",
      gasLimit: 70871,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
    {
      name: "ETH",
      slug: "eth-eth",
      network: "ethereum-rinkeby",
      address: "0x0000000000000000000000000000000000000000",
      cmcId: 1027,
      decimal: 18,
      type: "OTHERS",
      gasLimit: 91526,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
    {
      name: "DOT",
      slug: "dot-eth",
      network: "ethereum-rinkeby",
      address: "0x5E54Ae7a27603db1caB124B84E0A139a29E780aE",
      cmcId: 6636,
      decimal: 18,
      type: "OTHERS",
      gasLimit: 91526,
      isEnabled: true,
      confirmedBalance: "0",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0",
    },
  ],
  provider: 1,
  sharedSecret: "vFbDQtN9qWCc",
  createdAt: "2022-03-29T07:38:35.451Z",
  updatedAt: "2022-04-05T09:23:31.918Z",
  flexiblePaymentSettings: {
    type: 0,
    underPaymentThresholdValue: 0.1,
    underPaymentCurrency: "USD",
    overPaymentThresholdValue: 5,
    overPaymentCurrency: "USD",
  },
  security: {
    is2faEnabled: false,
    isEmailVerifyEnabled: false,
    emailCodeExp: 0,
  },
  missingWallet: [],
  missingCryptoCurrencySettings: [
    {
      name: "ZSD",
      slug: "zsd-bsc",
      network: "binance-smart-chain-testnet",
      address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
      cmcId: 8772,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
    {
      name: "WETH",
      slug: "eth-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
      cmcId: 2396,
      decimal: 18,
      type: "POPULAR",
      gasLimit: 70871,
    },
    {
      name: "ADA",
      slug: "ada-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x78e67d427480D18890C807B3be219A8777900EcB",
      cmcId: 2010,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
    {
      name: "LUNA",
      slug: "luna-bsc",
      network: "binance-smart-chain-testnet",
      address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
      cmcId: 4172,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
    {
      name: "SHIB",
      slug: "shib-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
      cmcId: 5994,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
    {
      name: "DOGE",
      slug: "doge-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
      cmcId: 74,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
    {
      name: "XRP",
      slug: "xrp-bsc",
      network: "binance-smart-chain-testnet",
      address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
      cmcId: 52,
      decimal: 18,
      type: "STABLE_COIN",
      gasLimit: 70871,
    },
  ],
  localExchangeRateByUsd: 1,
  backupCode: [
    "vUDxEwu1YP",
    "gArThHokQX",
    "zCYmN1ga8z",
    "Chv8p9v6Op",
    "_HwkkgQz7W",
    "hF10NsHmzx",
    "Z2pME2Op8V",
    "Zn9WR6Q018",
    "KaY9hTpnqt",
    "M3YRZi3xhY",
  ],
  apiKeys: [
    {
      id: "6242c62e1af56a02f251ff03",
      merchantId: "6242b77b96633f004182a26b",
      apiKey: "b6e2bb2b-8d3d-4208-b76d-7a62bd5debc8",
      createdAt: "2022-03-29T08:41:18.549Z",
      updatedAt: "2022-03-29T08:41:18.549Z",
    },
  ],
};

const serviceFeeData = 0.1;

export const onGetDefaultServiceFee = () => {
  axiosMockAdapterInstance.onGet("/settings/default-service-fee").reply(() => {
    return [200, getResponseData(serviceFeeData)];
  });
};

export const onPost = (values) => {
  axiosMockAdapterInstance.onPost(`settings/service-fee`, values).reply(() => {
    data.fizenpayFeePerc = values.serviceFee;
    return [200, getResponseData(data)];
  });
};
